export default __webpack_public_path__ + "static/media/review.515abd91.jpg";